import { writable } from 'svelte/store';

interface DownloadModalState {
	open: boolean;
	featureName: string;
}

function createDownloadModalStore() {
	const { subscribe, set, update } = writable<DownloadModalState>({
		open: false,
		featureName: 'Recording and transcription'
	});

	return {
		subscribe,
		open: (featureName: string = 'Recording and transcription') => {
			set({ open: true, featureName });
		},
		close: () => {
			update((state) => ({ ...state, open: false }));
		},
		reset: () => {
			set({ open: false, featureName: 'Recording and transcription' });
		}
	};
}

export const downloadModalStore = createDownloadModalStore();
